export default __webpack_public_path__ + "static/sticky_notes-45839719995133f58e8dc5cc130bf6a4.jpg";